/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {protect} from '../api'

export const useMutationProtect = createReactQueryMutationHook('protect', protect)
